'use strict';

var _ = require('lodash');
var JQXGridSettingsFactory = function JQXGridSettingsFactory(JQXGridColumnGroup, JQXGridColumn, GridColumnGroup, GridColumn, MomentConstants) {
  function convertToJQXColumnGroups(columns) {
    var groups = _.transform(columns, function (collection, item) {
      if (item instanceof GridColumnGroup) {
        collection.push(new JQXGridColumnGroup(item));
      }
    });
    return groups.length > 0 ? groups : null;
  }
  function convertToJQXColumns(columns, dataFields, parent, customRenderers) {
    var fieldToType = _.keyBy(dataFields, 'name');
    return _.transform(columns, function (collection, item) {
      if (item instanceof GridColumn) {
        if (fieldToType[item.field]) {
          item.dataFieldType = fieldToType[item.field].type;
        }
        collection.push(new JQXGridColumn(item, parent, customRenderers));
      } else if (item instanceof GridColumnGroup && !item.isEmpty()) {
        collection.push.apply(collection, convertToJQXColumns(item.columns, dataFields, item, customRenderers));
      }
    });
  }
  function updateOperand(column, operand, map) {
    var context = column.columnContext;
    if (context && context.formula && _.isString(context.formula[operand])) {
      var dependency = map[context.formula[operand]];
      if (dependency.columnContext !== undefined && dependency.columnContext.formula !== undefined) {
        context.formula[operand] = dependency.columnContext.formula;
      }
    }
  }

  // go through all jqx columns and replace string formulas with the actual formula objects
  function updateJQXColumnFormulas(jqxColumns) {
    var map = _.keyBy(jqxColumns, 'datafield');
    jqxColumns.forEach(function (col) {
      updateOperand(col, 'leftOperand', map);
      updateOperand(col, 'rightOperand', map);
    });
  }
  function getLocalization() {
    return {
      patterns: MomentConstants.FORMATS
    };
  }
  function getSelectionMode(showSelectionCheckboxes) {
    if (showSelectionCheckboxes) {
      return 'checkbox_multiplerowsadvanced';
    }
    return 'multiplecells';
  }
  function getHeight(heightSettings) {
    if (heightSettings) {
      return heightSettings;
    }
    return '100%';
  }
  function getJQXGridSettings(gridSettings, dataFields, customRenderers, showSelectionCheckboxes, tooltipHandler) {
    var jqxColumnGroups = convertToJQXColumnGroups(gridSettings.columns);
    var jqxColumns = convertToJQXColumns(gridSettings.columns, dataFields, null, customRenderers);
    updateJQXColumnFormulas(jqxColumns);
    var settings = {
      width: '100%',
      height: getHeight(gridSettings.height),
      autoheight: _.get(gridSettings, 'autoheight', false),
      altrows: true,
      editable: gridSettings.editable,
      sortable: true,
      filterable: true,
      enabletooltips: false,
      columnsresize: true,
      selectionmode: getSelectionMode(showSelectionCheckboxes),
      showsortcolumnbackground: false,
      showsortmenuitems: false,
      localization: getLocalization(),
      endCellEditRefreshDisabled: true,
      columngroups: jqxColumnGroups,
      columns: jqxColumns
    };
    if (_.filter(jqxColumns, 'tooltip').length > 0) {
      settings.cellhover = tooltipHandler;
    }
    if (gridSettings.columnsheight) {
      settings.columnsheight = gridSettings.columnsheight;
    }
    if (gridSettings.minrows) {
      settings.minrows = gridSettings.minrows;
    }
    if (gridSettings.maxrows) {
      settings.maxrows = gridSettings.maxrows;
    }
    return settings;
  }
  function getSimpleJQXGridSettings(gridSettings) {
    var jqxColumnGroups = convertToJQXColumnGroups(gridSettings.columns);
    var jqxColumns = convertToJQXColumns(gridSettings.columns);
    return {
      columngroups: jqxColumnGroups,
      columns: jqxColumns,
      localization: getLocalization(),
      endCellEditRefreshDisabled: true,
      altrows: true
    };
  }
  return {
    getJQXGridSettings: getJQXGridSettings,
    getSimpleJQXGridSettings: getSimpleJQXGridSettings,
    convertToJQXColumns: convertToJQXColumns,
    convertToJQXColumnGroups: convertToJQXColumnGroups,
    updateJQXColumnFormulas: updateJQXColumnFormulas
  };
};
JQXGridSettingsFactory.$inject = ['JQXGridColumnGroupFactory', 'JQXGridColumnFactory', 'GridColumnGroupFactory', 'GridColumnFactory', 'MomentConstants'];
module.exports = JQXGridSettingsFactory;